import Routes from "../routes";
import "react-toastify/dist/ReactToastify.css";

import { ToastContainer } from "react-toastify";


function App() {
  return (
    <>
      <Routes />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        className={`pro-toast-container`}
        progressClassName={`pro-toast-progress`}
        toastClassName={`pro-toast`}
        style={{ zIndex: 9999 }}
      />
    </>
  );
}

export default App;
